<template>
  <a :class="['sidebar-item-main', flag ? 'flag' : '']" :href="item.url" :target="item.target || '_self'"  @click="item.alertType ? $emit('click') : null">
    <!-- {{item}} -->
      <div class="left-model">
        <i :class="['iconfont', iconfontClass]" v-if="iconfontClass"></i>
        <img class="iconfont-img" :src="iconfontImg" v-if="iconfontImg">
        <div class="text text-overflow">{{text}}</div>
      </div>
      <div class="right-model">
        <div class="num" v-if="num">
          {{num}}
          <div class="num-tips" v-if="!isInbox">
            <img src="https://files.wondercv.com/pcvue/Group18%402x.png" alt="">
            <div class="num-close" @click="close"></div>
          </div>
        </div>
        <div class="new" v-if="isNew">
          <img src="https://files.wondercv.com/pcvue/new.png" alt="">
        </div>
        <div class="new tipsIcon autoGlow" v-if="item.tipsIcon">
          <img :src="item.tipsIcon" alt="">
        </div>
        <i class="iconfont iconchevron-right" v-if="rightIcon"></i>
      </div>
  </a>
</template>
<script>
export default {
  name: 'sidebarItem',
  props: {
    item:{},
    text: {
      type: String,
      required: true
    },
    iconfontClass: {
      type: String,
      required: false
    },
    iconfontImg: {
      type: String,
      required: false
    },
    num: {
      type: Number,
      required: false
    },
    flag: {
      type: Boolean,
      default: false,
      required: false
    },
    rightIcon: {
      type: Boolean,
      default: false
    },
    isNew: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isInbox: true
    };
  },
  created() {
    if (process.client) {
      this.isInbox = localStorage.getItem('inbox');
    } else {
      this.isInbox = true;
    }
  },
  methods: {
    close() {
      if (process.client) {
        localStorage.setItem('inbox', true);
        this.isInbox = true;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/assets/css/animation';

  .sidebar-item-main {
    // font-family: PingFangSC-Regular;
    width: 100%;
    height: 62px;
    background: #fff;
    border-bottom: 1px solid #EEF0F5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    position: relative;
    color: #404040;
    &:last-child {
      border: none;
    }
    &.flag {
      .text {
        font-weight: 600;
      }
    }
    &.flag::after {
      content: "";
      display: block;
      width: 3px;
      height: 26px;
      background: #FF453C;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
    }
    .left-model {
      height: 100%;
      display: flex;
      align-items: center;
      width: 100%;
      .iconfont {
        font-size: 18px;
        font-weight: 300;
        margin-left: 24px;
        line-height: 64px;
        margin-right: 18px;
      }
      .iconfont-img {
        width: auto;
        width: 28px;
        height: 28px;
        max-width: 28px;
        max-height: 28px;
        margin-left: 18px;
        margin-right: 14px;
      }
      .text {
        height: 100%;
        line-height: 62px;
        width: 100%;
        max-width: 160px;
        font-family: PingFangSC-Regular;
      }
    }
    .right-model {
      width: auto;
      display: flex;
      align-items: center;
      margin-right: 18px;
      flex: none;
      justify-content: flex-end;
      .num {
        width: 32px;
        height: 16px;
        line-height: 16px;
        color: #FFF;
        font-size: 12px;
        // padding: 0 16px;
        text-align: center;
        background: #ff4f4c;
        border-radius: 10px;
        position: relative;
        .num-tips {
          width: 220px;
          height: 70px;
          position: absolute;
          top: 50%;
          right: -7px;
          transform: translate(100%, -50%);
          z-index: 9;
          cursor: auto;
          img {
            width: 100%;
            height: 100%;
          }
          .num-close {
            width: 16px;
            height: 16px;
            position: absolute;
            top: 8px;
            right: 12px;
            cursor: pointer;
          }
        }
      }
      .new {
        width: 23px;
        height: 14px;
        position: absolute;
        top: 24px;
        right: 25px;
        display: flex;
        justify-content: flex-end;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .tipsIcon{
        width: 44px;
        height: 16px;
        position: absolute;
        top: 24px;
        right: 25px;
        display: flex;
        justify-content: flex-end;
        overflow: hidden;
        border-radius: 8px;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .iconfont {
        font-size: 18px;
        font-weight: 700;
        margin-left: 10px;
      }
    }
  }
</style>